export default __webpack_public_path__ + "static/media/Group9177.82c91baa.svg";